
import axios from "@/api/axios";
import Toast from "@/components/UI/Toast";
import qs from 'qs'
import Modal from "@/components/UI/Modal";
import { getCartInfo } from "@/api/useChangeShopCar";
const useShopCar = () => {

    //  后台存储
    function storgeBackstage(id: string, tid: number, qty: number, lotid: number, tcid: number,category: 2,cartType: number,checkValue: number) {
        const guid = localStorage.getItem('guid')
        const data = qs.stringify({
            pid: id,
            tid,
            qty,
            lotid,
            tcid,
            category:category,
            cartType,
            checkValue,
            cartGUID: guid,
        })
        axios.post('/M/Server/AddToCart', data)
            .then((res) => {
                if (res.data.success) {
                    if(res.data.shopCartGuid) {
                        localStorage.setItem('guid', res.data.shopCartGuid)
                    }
                    if(!guid || guid == 'null'){
                        localStorage.setItem('guid', res.data.shopCartGuid)
                    }
                    getCartInfo()
                    if(cartType == 1){
                        Toast({
                            type: "success",
                            title: "提交成功，可前往购物车查看",
                        });
                    }else{
                        Toast({
                            type: "success",
                            title: res.data.msg,
                        });
                    }
                } else {
                    Toast({
                        type: "error",
                        title: res.data.msg,
                    });
                }
            })
            .catch((err) => {
                console.log('err');
            });
    }
    function addShopCar(id: string, tid: number, qty: number, lotid: number, tcid: number, stock: number,category: 2) {

        // console.log("111:"+lotid)
        // console.log("2222:"+tcid)
        console.log("33333" +category)
        if ((typeof stock == 'number') && stock<1 && (tid == 0 || tid == 4)) {
            Modal({
                title: "温馨提示",
                // content: "库存不足，可能影响货期。建议更换其它同类产品，是否继续？",
                content: '<div>库存不足，可能影响货期。<br/>建议更换其它同类产品，是否继续？</div>',
                dangerouslyUseHTMLString: true,
                onConfirm: () => {
                    storgeBackstage(id, tid, qty,lotid,tcid,category,0,0)
                },
                onCancel: () => {
                    console.log('取消')
                },
            });
        } else {
            storgeBackstage(id, tid, qty,lotid,tcid,category,0,0)
        }
        // storgeBackstage(id, tid, qty,lotid)

    }


    function updatecommodity(id: string, qty: number) {
        const guid = localStorage.getItem('guid')
        const data = qs.stringify({
            pid: id,
            qty: qty,
            cartGUID: guid
        })
        axios.post('/M/Server/UpdateCartItem', data).then((res) => {
            if (res.data.success) {
                // Toast({
                //     type: "success",
                //     title: res.data.msg,
                // });
                getCartInfo()
            } else {
                Toast({
                    type: "error",
                    title: res.data.msg,
                });
            }
        })
            .catch((err) => {
                console.log('err');
            });


    }
    function addStorge(id: string, qty: number) {

        updatecommodity(id, qty)

    }
    function subStorge(id: string, qty: number) {

        updatecommodity(id, qty)

    }


    return {
        addShopCar,
        addStorge,
        subStorge,
        storgeBackstage
    }

}

export default useShopCar
